<template>
  <div style="margin-left: 20">
    <div class="container">
      <div class="row">
        <table>
          <tr>
            <td>
              <h3 style="margin-top: 10; margin-left: 50">Report</h3>
            </td>
          </tr>
          <tr>
            <td>
              <strong>Report Type</strong>
              <span style="margin-left: 180px">
                <select v-model="reportType" @change="checkReportFlag" required>
                  <option selected>Overall Report</option>
                  <option
                    v-for="reportType in reportTypes"
                    v-bind:key="reportType.id"
                  >
                    {{ reportType }}
                  </option>
                </select>
              </span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <form id="form_id" ref="form" @submit.prevent="processForm">
      <div class="container">
        <div class="row" v-if="singleGroup">
          <table class="table-horizontal" width="100%" height="20">
            <tbody>
              <tr>
                <td><strong>Group Name</strong></td>
                <td v-if="groups.length === 1">
                  <input
                    class="mumbai grayout"
                    readonly="true"
                    v-model="group"
                    @change="onGroupChange"
                  />
                </td>
                <td v-else>
                  <select
                    class="mumbai"
                    v-model="group"
                    @change="onGroupChange"
                  >
                    <option selected>-Select-</option>
                    <option
                      v-for="group in groups"
                      v-bind:key="group.id"
                      v-bind:id="group"
                    >
                      {{ group }}
                    </option>
                  </select>
                </td>
                <td><strong>Function Supported</strong></td>
                <td>
                  <div id="functionsupporteddiv">
                    <select
                      class="mumbai"
                      v-model="functionSupported"
                      @change="onFunctionChange"
                    >
                      <option selected>-Select-</option>
                      <option
                        v-for="functionSupported in functionSupporteds"
                        v-bind:key="functionSupported.id"
                      >
                        {{ functionSupported }}
                      </option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>Tasks Performed</strong></td>
                <td v-if="group === 'CORPORATE'">
                  <div
                    v-if="
                      functionSupported === 'Research' ||
                      functionSupported === 'Adhoc'
                    "
                    id="divTaskPerformed"
                  >
                    <td>
                      <input
                        class="mumbai"
                        type="text"
                        name="taskperformed"
                        size="29"
                        v-model="task_performed"
                      />
                    </td>
                  </div>
                  <div v-else id="divTaskPerformed">
                    <select class="mumbai" v-model="task_performed">
                      <option selected>-Select-</option>
                      <option
                        v-for="task_performed in task_performeds"
                        v-bind:key="task_performed.id"
                      >
                        {{ task_performed }}
                      </option>
                    </select>
                  </div>
                </td>

                <td v-else>
                  <div id="divTaskPerformed">
                    <select class="mumbai" v-model="task_performed">
                      <option selected>-Select-</option>
                      <option
                        v-for="task_performed in task_performeds"
                        v-bind:key="task_performed.id"
                      >
                        {{ task_performed }}
                      </option>
                    </select>
                  </div>
                </td>
                <td><strong>Analyst</strong></td>
                <td>
                  <combobox
                    :disabled="stockReportFlag"
                    class="mumbai"
                    type="email"
                    name="mumbaianalystid"
                    :emails="emails"
                    v-model="mumbaianalystid"
                    size="29"
                  ></combobox>
                </td>
              </tr>

              <tr>
                <td><strong>Date Range (MM-DD-YYYY)</strong></td>
                <td>
                  <div class="flex-container">
                    <DatePicker
                      v-model="range.start"
                      mode="date"
                      :masks="masks"
                      color="blue"
                    >
                      <template
                        class="flex-child"
                        v-slot="{
                          inputValue,
                          inputEvents,
                          isDragging,
                          togglePopover,
                        }"
                      >
                        <input
                          class="reportDate"
                          :class="
                            isDragging ? 'text-gray-600' : 'text-gray-900'
                          "
                          :value="inputValue"
                          v-on="inputEvents"
                        />
                        <svg
                          style="
                            padding: 0px;
                            margin-left: -24px;
                            margin-top: 9px;
                          "
                          @click.stop.prevent="togglePopover()"
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="26"
                          fill="currentColor"
                          class="bi bi-calendar"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                          />
                        </svg>
                        <span>&ensp;</span>
                      </template>
                    </DatePicker>
                    <DatePicker
                      v-model="range.end"
                      mode="date"
                      :masks="masks"
                      color="blue"
                    >
                      <template
                        class="flex-child"
                        v-slot="{
                          inputValue,
                          inputEvents,
                          isDragging,
                          togglePopover,
                        }"
                      >
                        <input
                          class="reportDate"
                          :class="
                            isDragging ? 'text-gray-600' : 'text-gray-900'
                          "
                          :value="inputValue"
                          v-on="inputEvents"
                        />
                        <svg
                          style="
                            padding: 0px;
                            margin-left: -24px;
                            margin-top: 9px;
                          "
                          @click.stop.prevent="togglePopover()"
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="26"
                          fill="currentColor"
                          class="bi bi-calendar"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                          />
                        </svg>
                      </template>
                    </DatePicker>
                  </div>
                </td>
                <td><strong>Feedback Score</strong></td>
                <td>
                  <select
                    :disabled="stockReportFlag"
                    class="mumbai"
                    v-model="selectedfdbscore"
                    id="feedbackscore"
                  >
                    <option
                      v-for="fdbscr in feedbackscoreArr"
                      v-bind:value="{ id: fdbscr.id, text: fdbscr.text }"
                      v-bind:key="fdbscr.id"
                    >
                      {{ fdbscr.text }}
                    </option>
                  </select>
                </td>
              </tr>

              <tr>
                <td><strong>Report Type</strong></td>
                <td>
                  <div>
                    <select
                      class="mumbai"
                      v-model="reportType"
                      @change="checkReportFlag"
                    >
                      <option selected>Overall Report</option>
                      <option
                        v-for="reportType in reportTypes"
                        v-bind:key="reportType.id"
                      >
                        {{ reportType }}
                      </option>
                    </select>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="row" v-else>
          <table class="table-horizontal">
            <tbody>
              <tr>
                <td><strong>Group Name</strong></td>
                <td colspan="3">
                  <table class="table-horizontal">
                    <tr>
                      <div>
                        <td>
                          <div
                            class="checkBox"
                            v-for="item in groups"
                            v-bind:key="item.id"
                          >
                            <input
                              v-if="item === 'All'"
                              type="checkbox"
                              v-model="allSelected"
                              :id="item"
                              :value="item"
                              @click="selectAll"
                            />
                            <input
                              v-else
                              type="checkbox"
                              v-model="selectedGroups"
                              :id="item"
                              :value="item"
                              @change="checkSelectAll"
                            />
                            <label style="padding-left: 5px" :for="item.id">{{
                              item
                            }}</label>
                          </div>
                        </td>
                      </div>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr v-if="singleGroup">
                <td><strong>Function Supported</strong></td>
                <td>
                  <div id="functionsupporteddiv">
                    <select
                      class="mumbai"
                      v-model="functionSupported"
                      @change="onFunctionChange"
                    >
                      <option selected>-Select-</option>
                      <option
                        v-for="functionSupported in functionSupporteds"
                        v-bind:key="functionSupported.id"
                      >
                        {{ functionSupported }}
                      </option>
                    </select>
                  </div>
                </td>

                <td><strong>Tasks Performed</strong></td>
                <td v-if="group === 'CORPORATE'">
                  <div
                    v-if="
                      functionSupported === 'Research' ||
                      functionSupported === 'Adhoc'
                    "
                    id="divTaskPerformed"
                  >
                    <td>
                      <input
                        class="mumbai"
                        type="text"
                        name="taskperformed"
                        size="29"
                        v-model="task_performed"
                      />
                    </td>
                  </div>
                  <div v-else id="divTaskPerformed">
                    <select class="mumbai" v-model="task_performed">
                      <option selected>-Select-</option>
                      <option
                        v-for="task_performed in task_performeds"
                        v-bind:key="task_performed.id"
                      >
                        {{ task_performed }}
                      </option>
                    </select>
                  </div>
                </td>

                <td v-else>
                  <div id="divTaskPerformed">
                    <select class="mumbai" v-model="task_performed">
                      <option selected>-Select-</option>
                      <option
                        v-for="task_performed in task_performeds"
                        v-bind:key="task_performed.id"
                      >
                        {{ task_performed }}
                      </option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>Date Range (MM-DD-YYYY)</strong></td>
                <td>
                  <div class="flex-container">
                    <DatePicker
                      v-model="range.start"
                      mode="date"
                      :masks="masks"
                      color="blue"
                    >
                      <template
                        class="flex-child"
                        v-slot="{
                          inputValue,
                          inputEvents,
                          isDragging,
                          togglePopover,
                        }"
                      >
                        <input
                          class="reportDate"
                          :class="
                            isDragging ? 'text-gray-600' : 'text-gray-900'
                          "
                          :value="inputValue"
                          v-on="inputEvents"
                        />
                        <svg
                          style="
                            padding: 0px;
                            margin-left: -24px;
                            margin-top: 9px;
                          "
                          @click.stop.prevent="togglePopover()"
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="26"
                          fill="currentColor"
                          class="bi bi-calendar"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                          />
                        </svg>
                        <span>&ensp;</span>
                      </template>
                    </DatePicker>
                    <DatePicker
                      v-model="range.end"
                      mode="date"
                      :masks="masks"
                      color="blue"
                    >
                      <template
                        class="flex-child"
                        v-slot="{
                          inputValue,
                          inputEvents,
                          isDragging,
                          togglePopover,
                        }"
                      >
                        <input
                          class="reportDate"
                          :class="
                            isDragging ? 'text-gray-600' : 'text-gray-900'
                          "
                          :value="inputValue"
                          v-on="inputEvents"
                        />
                        <svg
                          style="
                            padding: 0px;
                            margin-left: -24px;
                            margin-top: 9px;
                          "
                          @click.stop.prevent="togglePopover()"
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="26"
                          fill="currentColor"
                          class="bi bi-calendar"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                          />
                        </svg>
                      </template>
                    </DatePicker>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>Analyst</strong></td>
                <td>
                  <combobox
                    :emails="emails"
                    :disabled="stockReportFlag"
                    class="mumbai"
                    type="email"
                    name="mumbaianalystid"
                    v-model="mumbaianalystid"
                    size="29"
                  ></combobox>
                </td>
              </tr>
              <tr>
                <td><strong>Feedback Score</strong></td>
                <td>
                  <select
                    :disabled="stockReportFlag"
                    class="mumbai"
                    v-model="selectedfdbscore"
                    id="feedbackscore"
                  >
                    <option
                      v-for="fdbscr in feedbackscoreArr"
                      v-bind:value="{ id: fdbscr.id, text: fdbscr.text }"
                      v-bind:key="fdbscr.id"
                    >
                      {{ fdbscr.text }}
                    </option>
                  </select>
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <button
            style="margin-top: 20px"
            type="submit"
            :disabled="isnotActive"
            v-on:click="downloadData"
          >
            Download Report
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <button style="margin-top: 20px" v-on:click="resetData()">
            Reset
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import store from "@/store";
import { DatePicker } from "v-calendar";
import "v-calendar/dist/style.css";
import moment from "moment";
import lodash from "lodash";
import combobox from "@/reusableComponents/comboBox";
export default {
  components: {
    DatePicker,
    combobox,
  },
  name: "HelloWorld",
  setup() {
    return {
      store,
    };
  },
  props: { msg: String },
  data() {
    return {
      range: {
        start: new Date(
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        ),
        end: new Date(),
      },
      masks: {
        input: "MM-DD-YYYY",
      },
      rootUrl: "process.env.VUE_APP_BACKEND_API/",
      Url: "reportData?",
      respReportUrl: "responseReportData",
      isnotActive: false,
      message: false,
      files: [],
      attach: [],
      feeddate: "",
      companyname: "",
      functionSupported: "-Select-",
      task_performed: "-Select-",
      usanalystid: "",
      mumbaianalystid: "",
      selecteddtrange: { id: 0, text: "-Select-" },
      selectedfdbscore: { id: 0, text: "-Select-" },
      group: "-Select-",
      funcsuppfilteredArr: [],
      taskperformfilteredArr: [],
      groupbydataArr: {},
      jsonresponse: [],
      groups: [],
      selectedGroups: [],
      selectedGroupsId: [],
      allSelected: false,
      singleGroup: false,
      selected: [],
      groupArr: [
        "ABS",
        "CASHFLOW",
        "CMBS",
        "CORPORATE",
        "CREDIT ESTIMATE",
        "group",
        "EMEA RMBS/ABS",
        "FIG",
        "RMBS",
        "STRUCTURED CREDIT",
      ],
      functionSupporteds: ["New Issuance", "Surveillance", "Research", "Adhoc"],
      function_json: {
        RMBS: ["New Issuance", "Surveillance"],
        CMBS: ["New Issuance", "Surveillance", "Research"],
        FIG: ["New Issuance", "Surveillance", "Research", "Adhoc"],
        STRUCTURED_CREDIT: ["New Issuance", "Surveillance", "Research"],
        CORPORATE: ["New Issuance", "Surveillance", "Research", "Adhoc"],
        ABS: ["New Issuance", "Surveillance"],
        Credit_Estimate: ["New Issuance", "Surveillance"],
        CASHFLOW: ["New Issuance", "Surveillance"],
        CANADIAN_SF: ["Surveillance"],
      },
      task_performeds: [],
      task_json: {
        FIG: {
          "New Issuance": ["IAX", "RC Package prep"],
          Surveillance: ["IAX", "RC Package prep"],
          Research: ["IAX"],
          Adhoc: ["IAX"],
        },
        RMBS: { "New Issuance": ["Non-SFR", "SFR"], Surveillance: ["SFR"] },
        EMEA: {
          "New Issuance": ["Par Report"],
          Surveillance: ["Par Report", "Memo/Press Release"],
          Research: ["Par Report"],
        },
        CMBS: {
          "New Issuance": [
            "NCF Analysis",
            "NCF Set-ups",
            "Presale",
            "Deal Support_SA",
            "Deal Support_DA",
          ],
          Surveillance: [
            "Deal Surveillance",
            "CRE CLO RAC requests",
            "NCF Analysis",
            "BP Updates Write-up",
          ],
          Research: [
            "Deal Surveillance",
            "CRE CLO RAC requests",
            "BP Updates Write-up",
          ],
        },
        STRUCTURED_CREDIT: {
          "New Issuance": [
            "Model",
            "Memo or Presale or Publication",
            "Entire Deal",
          ],
          Surveillance: [
            "Model_Surveillance",
            "Memo or Presale or Publication",
            "Entire Deal_Surveillance",
          ],
          Research: ["Research Support"],
        },
        CORPORATE: {
          "New Issuance": [
            "Data Mining",
            "Data mining and Forecasting",
            "Contribution to RC Memo",
          ],
          Surveillance: [
            "Data Mining",
            "Data mining and Forecasting",
            "Contribution to RC Memo",
          ],
          Research: [""],
          Adhoc: [""],
        },
        ABS: {
          "New Issuance": [
            "Entire Deal",
            "Preparation of Model Input Data",
            "Memo/Presale/Publication",
            "Administrative Tasks",
          ],
          Surveillance: [
            "Hydra Mapping / PAR Creation",
            "PAR QC",
            "Discussion Group",
            "SRC",
            "Model",
            "Administrative Tasks",
            "Publication",
          ],
        },
        Credit_Estimate: {
          "New Issuance": ["Credit Estimate Cases"],
          Surveillance: ["Credit Estimate Cases"],
        },
        CASHFLOW: {
          "New Issuance": ["Cashflow Analytics"],
          Surveillance: ["Cashflow Analytics"],
        },
        CANADIAN_SF: {
          Surveillance: [
            "Data Extraction",
            "New Deal Template Setup",
            "Surveillance Report",
          ],
        },
      },
      groupFuncTaskMapArr: {
        1: [
          { 1: ["1", "2", "3", "26"] },
          { 2: ["4", "5", "6", "7", "8", "26", "27"] },
        ],
        2: [
          { 1: ["9", "10", "11"] },
          { 2: ["12", "13", "14"] },
          { 3: ["12", "13", "14"] },
        ],
        3: [
          { 1: ["15", "16", "17"] },
          { 2: ["15", "16", "17"] },
          { 3: ["15", "16", "17"] },
          { 4: [] },
        ],
        4: [{ 1: ["18"] }, { 2: ["18"] }],
        5: [{ 1: ["19"] }, { 2: ["19"] }, { 3: ["19"] }],
        6: [{ 1: ["20", "21"] }, { 2: ["21"] }],
        7: [{ 1: ["8", "3", "1"] }, { 2: ["23", "3", "24"] }, { 3: ["25"] }],
        8: [{ 1: ["22"] }, { 2: ["22"] }],
      },
      dtrangeArr: [
        { id: 0, text: "-Select-" },
        { id: 1, text: "Last 1 Month" },
        { id: 3, text: "Last 3 Months" },
        { id: 6, text: "Last 6 Months" },
        { id: 12, text: "Last 12 Months" },
      ],
      feedbackscoreArr: [
        { id: 0, text: "-Select-" },
        { id: 1, text: "1" },
        { id: 2, text: "2" },
        { id: 3, text: "3" },
        { id: 4, text: "4" },
        { id: 5, text: "5" },
      ],
      objVal: {},
      reportTypes: [
        "Quality %",
        "Timeliness %",
        "Quality Average Score",
        "Response Rate %",
        "Team Lead/ Manager Comments",
      ],
      reportType: "Overall Report",
      qualityJson: {},
      quality: {},
      timeliness: {},
      qualityAverageScore: {},
      stockReportFlag: true,
      emails: [],
      usAnalystFlag: false,
    };
  },
  async beforeCreate() {
    const getUrl = new URL(process.env.VUE_APP_BACKEND_API + "getEmails");
    this.groups = store.methods.getGroup();

    getUrl.searchParams.append("group", this.groups);

    const response = await axios
      .get(getUrl)
      .then((response) => (this.jsonresponse = response))
      .catch((error) => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
      });
    this.jsonresponse = response.data;
    this.emails = this.jsonresponse.map((data) => {
      return data["email"];
    });
  },
  created: function () {
    this.groups = store.methods.getGroup();

    if (this.groups.length === 1) {
      this.group = this.groups[0];
      this.singleGroup = true;
      if (this.group === "EMEA RMBS/ABS") {
        this.functionSupporteds = Object.keys(this.task_json.EMEA);
        this.message = true;
      } else if (this.group === "STRUCTURED CREDIT") {
        this.functionSupporteds = Object.keys(this.task_json.STRUCTURED_CREDIT);
        this.message = false;
      } else if (
        this.group === "CREDIT ESTIMATE" ||
        this.group === "Credit Estimate"
      ) {
        this.functionSupporteds = Object.keys(this.task_json.Credit_Estimate);
        this.message = false;
      } else if (this.group === "CANADIAN SF") {
        this.functionSupporteds = Object.keys(this.task_json.CANADIAN_SF);
        this.message = false;
      } else {
        this.functionSupporteds = Object.keys(this.task_json[this.group]);
        this.message = false;
      }
    } else {
      this.groups = [...["All"], ...this.groups];
    }
    this.checkReportFlag();
  },
  methods: {
    selectAll() {
      this.selectedGroups = [];

      if (!this.allSelected) {
        for (let user in this.groups) {
          this.selectedGroups.push(this.groups[user]);
        }
        if (this.selectedGroups[0] === "All") {
          this.selectedGroups.shift();
        }
      }
    },
    checkReportFlag() {
      if (this.reportType !== "Overall Report") {
        this.mumbaianalystid = "";
        this.selectedfdbscore = { id: 0, text: "-Select-" };
        return (this.stockReportFlag = true);
      }
      return (this.stockReportFlag = false);
    },
    checkSelectAll() {
      if (this.groups.length - 1 === this.selectedGroups.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    },
    onGroupChange() {
      if (this.group === "EMEA RMBS/ABS") {
        this.functionSupporteds = Object.keys(this.task_json.EMEA);
        this.message = true;
      } else if (this.group === "STRUCTURED CREDIT") {
        this.functionSupporteds = Object.keys(this.task_json.STRUCTURED_CREDIT);
        this.message = false;
      } else if (
        this.group === "CREDIT ESTIMATE" ||
        this.group === "Credit Estimate"
      ) {
        this.functionSupporteds = Object.keys(this.task_json.Credit_Estimate);
        this.message = false;
      } else if (this.group === "CANADIAN SF") {
        this.functionSupporteds = Object.keys(this.task_json.CANADIAN_SF);
        this.message = false;
      } else {
        this.functionSupporteds = Object.keys(this.task_json[this.group]);
        this.message = false;
      }
      this.onFunctionChange();
    },

    onFunctionChange() {
      if (this.group === "EMEA RMBS/ABS") {
        this.task_performeds = this.task_json["EMEA"][this.functionSupported];
      } else if (this.group === "STRUCTURED CREDIT") {
        this.task_performeds =
          this.task_json["STRUCTURED_CREDIT"][this.functionSupported];
      } else if (
        this.group === "CREDIT ESTIMATE" ||
        this.group === "Credit Estimate"
      ) {
        this.task_performeds =
          this.task_json["Credit_Estimate"][this.functionSupported];
      } else if (this.group === "CANADIAN SF") {
        this.task_performeds =
          this.task_json["CANADIAN_SF"][this.functionSupported];
      } else if (this.group === "CORPORATE") {
        if (
          this.functionSupported !== "Research" ||
          this.functionSupported !== "Research"
        ) {
          this.task_performeds =
            this.task_json[this.group][this.functionSupported];
        }
      } else {
        this.task_performeds =
          this.task_json[this.group][this.functionSupported];
      }
      if (this.task_performed) {
        this.task_performed = "-Select-";
      }
    },
    validateReport() {
      var flag = true;
      var message = "";
      if (this.range.end.getTime() < this.range.start.getTime()) {
        flag = false;
        message = "Please select correct date range";
      }

      if (this.usanalystid.length > 0) {
        if (!/@morningstar.com$/.test(this.usanalystid)) {
          flag = false;
          message = "Please enter 'morningstar' emailid for primary analyst";
        }
      }
      // if(this.group === )
      if (flag == false) {
        alert(message);
      }
      return flag;
    },
    qualityReport() {
      let res = this.jsonresponse;
      let resAlt = this.jsonresponse;
      let montharr = ["Group"];
      res.map((current) => {
        let month = current["feedReceivedDate"]
          ? moment(moment(current["feedReceivedDate"], "YYYY-MM-DD")).format(
              "MMMM YY",
            )
          : "";
        return (current["feedReceivedDate"] = month);
      });
      res.map((current) => {
        let month = current["feedDate"]
          ? moment(moment(current["feedDate"], "YYYY-MM-DD")).format("MMMM YY")
          : "";
        if (!montharr.includes(month) && month !== "") {
          montharr.push(month);
        }
        return (current["feedDate"] = month);
      });

      //filtering valid request
      res = lodash.filter(res, (current) => {
        return current["feedReceivedDate"] && parseInt(current["overAllFeed"]);
      });

      const reducedGrouped = lodash.groupBy(res, "feedDate");

      //try to bifurcate using groupname
      for (let a in reducedGrouped) {
        reducedGrouped[a] = lodash.groupBy(reducedGrouped[a], "groupName");
      }

      for (let a in reducedGrouped) {
        for (let i in reducedGrouped[a]) {
          reducedGrouped[a][i] = reducedGrouped[a][i].length;
        }
      }

      let filteredResponse = lodash.filter(resAlt, (current) => {
        return (
          current["feedReceivedDate"] && parseInt(current["overAllFeed"]) >= 3
        );
      });

      const filteredreducedGrouped = lodash.groupBy(
        filteredResponse,
        "feedDate",
      );

      //try to bifurcate using groupname
      for (let a in filteredreducedGrouped) {
        filteredreducedGrouped[a] = lodash.groupBy(
          filteredreducedGrouped[a],
          "groupName",
        );
      }

      for (let a in filteredreducedGrouped) {
        if (!filteredreducedGrouped[a]) {
          filteredreducedGrouped[a] = {};
        }
        for (let i in filteredreducedGrouped[a]) {
          if (!filteredreducedGrouped[a][i]) {
            filteredreducedGrouped[a][i] = {};
          }
          filteredreducedGrouped[a][i] = filteredreducedGrouped[a][i].length;
        }
      }

      //Comparing objects to get total quality
      for (let a in reducedGrouped) {
        this.quality[a] = {};
        for (let i in reducedGrouped[a]) {
          this.quality[a][i] =
            filteredreducedGrouped[a] && filteredreducedGrouped[a][i]
              ? (filteredreducedGrouped[a][i] / reducedGrouped[a][i]) * 100
              : 0;
        }
      }

      let groups =
        this.groups.length > 1 && !this.group
          ? this.selectedGroups
          : this.groups;
      groups = lodash.sortBy(groups.filter((group) => group != "All"));

      let arr = [...Array(groups.length + 2)].map(() =>
        [...Array(montharr.length)].map(() => ""),
      );
      let count = [...Array(montharr.length)].map(() => 0);
      let sum = [...Array(montharr.length)].map(() => 0);

      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < montharr.length; j++) {
          if (!this.quality[montharr[j]]) {
            this.quality[montharr[j]] = 0;
          }

          if (i == 0) {
            arr[i][j] = montharr[j];
          } else if (j == 0) {
            arr[i][j] = i == arr.length - 1 ? "Grand Total" : groups[i - 1];
          } else if (i != arr.length - 1) {
            if (this.quality[montharr[j]][groups[i - 1]]) {
              arr[i][j] =
                this.quality[montharr[j]][groups[i - 1]].toFixed(2) + "%";
              count[j]++;
              sum[j] += this.quality[montharr[j]][groups[i - 1]];
            } else {
              arr[i][j] = "NA";
            }
          } else {
            arr[i][j] =
              count[j] != 0 ? (sum[j] / count[j]).toFixed(2) + "%" : "NA";
          }
        }
      }
      return arr;
    },
    timelinessReport() {
      let res = this.jsonresponse;
      const resAlt = this.jsonresponse;
      let montharr = ["Group"];
      res.map((current) => {
        let month = current["feedReceivedDate"]
          ? moment(moment(current["feedReceivedDate"], "YYYY-MM-DD")).format(
              "MMMM YY",
            )
          : "";
        return (current["feedReceivedDate"] = month);
      });
      res.map((current) => {
        let month = current["feedDate"]
          ? moment(moment(current["feedDate"], "YYYY-MM-DD")).format("MMMM YY")
          : "";
        if (!montharr.includes(month) && month !== "") {
          montharr.push(month);
        }
        return (current["feedDate"] = month);
      });

      //filtering valid request
      res = lodash.filter(res, (current) => {
        return current["feedReceivedDate"];
      });

      const reducedGrouped = lodash.groupBy(res, "feedDate");

      for (let a in reducedGrouped) {
        reducedGrouped[a] = lodash.groupBy(reducedGrouped[a], "groupName");
      }

      for (let a in reducedGrouped) {
        for (let i in reducedGrouped[a]) {
          reducedGrouped[a][i] = reducedGrouped[a][i].length;
        }
      }

      let filteredResponse = lodash.filter(resAlt, (current) => {
        return current["timeliNess"] === "Met" && current["feedReceivedDate"];
      });

      const filteredreducedGrouped = lodash.groupBy(
        filteredResponse,
        "feedDate",
      );

      //try to bifurcate using groupname
      for (let a in filteredreducedGrouped) {
        filteredreducedGrouped[a] = lodash.groupBy(
          filteredreducedGrouped[a],
          "groupName",
        );
      }

      for (let a in filteredreducedGrouped) {
        for (let i in filteredreducedGrouped[a]) {
          filteredreducedGrouped[a][i] = filteredreducedGrouped[a][i].length;
        }
      }

      //Comparing objects to get total timeliness
      for (let a in reducedGrouped) {
        this.timeliness[a] = {};
        for (let i in reducedGrouped[a]) {
          this.timeliness[a][i] =
            filteredreducedGrouped[a] && filteredreducedGrouped[a][i]
              ? (filteredreducedGrouped[a][i] / reducedGrouped[a][i]) * 100
              : 0;
        }
      }

      let groups =
        this.groups.length > 1 && !this.group
          ? this.selectedGroups
          : this.groups;
      groups = lodash.sortBy(groups.filter((group) => group != "All"));

      let count = [...Array(montharr.length)].map(() => 0);
      let sum = [...Array(montharr.length)].map(() => 0);

      let arr = [...Array(groups.length + 2)].map(() =>
        [...Array(montharr.length)].map(() => ""),
      );

      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < montharr.length; j++) {
          if (!this.timeliness[montharr[j]]) {
            this.timeliness[montharr[j]] = 0;
          }
          if (i == 0) {
            arr[i][j] = montharr[j] ? montharr[j] : 0;
          } else if (j == 0) {
            arr[i][j] = i == arr.length - 1 ? "Grand Total" : groups[i - 1];
          } else if (i != arr.length - 1) {
            if (this.timeliness[montharr[j]][groups[i - 1]]) {
              arr[i][j] =
                this.timeliness[montharr[j]][groups[i - 1]].toFixed(2) + "%";
              count[j]++;
              sum[j] += this.timeliness[montharr[j]][groups[i - 1]];
            } else {
              arr[i][j] = "NA";
            }
          } else {
            arr[i][j] =
              count[j] != 0 ? (sum[j] / count[j]).toFixed(2) + "%" : "NA";
          }
        }
      }
      return arr;
    },
    qualityAverageScoreReport() {
      let res = this.jsonresponse;
      const resAlt = this.jsonresponse;
      let montharr = ["Group"];
      //converted date to month
      res.map((current) => {
        let month = current["feedReceivedDate"]
          ? moment(moment(current["feedReceivedDate"], "YYYY-MM-DD")).format(
              "MMMM YY",
            )
          : "";

        return (current["feedReceivedDate"] = month);
      });
      res.map((current) => {
        let month = current["feedDate"]
          ? moment(moment(current["feedDate"], "YYYY-MM-DD")).format("MMMM YY")
          : "";
        if (!montharr.includes(month) && month !== "") {
          montharr.push(month);
        }
        return (current["feedDate"] = month);
      });

      res = lodash.filter(res, (current) => {
        return current["feedReceivedDate"] && parseInt(current["overAllFeed"]);
      });

      //grouped using feeddate
      const reducedGrouped = lodash.groupBy(res, "feedDate");

      //grouped using groupName
      for (let a in reducedGrouped) {
        reducedGrouped[a] = lodash.groupBy(reducedGrouped[a], "groupName");
      }

      let filteredResponse = lodash.filter(resAlt, (current) => {
        return current["feedReceivedDate"] && parseInt(current["overAllFeed"]);
      });

      const filteredreducedGrouped = lodash.groupBy(
        filteredResponse,
        "feedDate",
      );

      //try to bifurcate using groupname
      for (let a in filteredreducedGrouped) {
        filteredreducedGrouped[a] = lodash.groupBy(
          filteredreducedGrouped[a],
          "groupName",
        );
      }

      //Comparing objects to get total timeliness
      for (let a in reducedGrouped) {
        this.qualityAverageScore[a] = {};

        if (!reducedGrouped[a]) {
          reducedGrouped[a] = 0;
        } else {
          for (let i in reducedGrouped[a]) {
            let sum = 0;
            if (filteredreducedGrouped[a] && filteredreducedGrouped[a][i]) {
              for (let j of filteredreducedGrouped[a][i]) {
                sum = sum + parseInt(j.overAllFeed);
              }
              this.qualityAverageScore[a][i] =
                sum / filteredreducedGrouped[a][i].length
                  ? parseFloat(
                      (sum / filteredreducedGrouped[a][i].length).toFixed(2),
                    )
                  : 0;
            }
          }
        }
      }

      let groups =
        this.groups.length > 1 && !this.group
          ? this.selectedGroups
          : this.groups;
      groups = lodash.sortBy(groups.filter((group) => group != "All"));

      let count = [...Array(montharr.length)].map(() => 0);
      let sum = [...Array(montharr.length)].map(() => 0);
      let arr = [...Array(groups.length + 2)].map(() =>
        [...Array(montharr.length)].map(() => ""),
      );

      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < montharr.length; j++) {
          if (!this.qualityAverageScore[montharr[j]]) {
            this.qualityAverageScore[montharr[j]] = 0;
          }
          if (i == 0) {
            arr[i][j] = montharr[j] ? montharr[j] : 0;
          } else if (j == 0) {
            arr[i][j] = i == arr.length - 1 ? "Grand Total" : groups[i - 1];
          } else if (i != arr.length - 1) {
            if (this.qualityAverageScore[montharr[j]][groups[i - 1]]) {
              arr[i][j] = this.qualityAverageScore[montharr[j]][groups[i - 1]];
              count[j]++;
              sum[j] += this.qualityAverageScore[montharr[j]][groups[i - 1]];
            } else {
              arr[i][j] = "-";
            }
          } else {
            arr[i][j] = count[j] != 0 ? (sum[j] / count[j]).toFixed(2) : "NA";
          }
        }
      }

      return arr;
    },
    downloadTabularData() {
      const reportTableUri = new URL(
        process.env.VUE_APP_BACKEND_API + this.Url,
      );

      if (this.groups.length > 1 && !this.group) {
        reportTableUri.searchParams.append("group", this.selectedGroups);
        reportTableUri.searchParams.append(
          "startDate",
          this.formatDate(this.range.start),
        );
        reportTableUri.searchParams.append(
          "endDate",
          this.formatDate(this.range.end),
        );
        reportTableUri.searchParams.append("reportType", this.reportType);
      } else {
        reportTableUri.searchParams.append("group", this.group);
        reportTableUri.searchParams.append(
          "functionsupported",
          this.functionSupported,
        );
        reportTableUri.searchParams.append(
          "tasksperformed",
          this.task_performed,
        );
        reportTableUri.searchParams.append(
          "startDate",
          this.formatDate(this.range.start),
        );
        reportTableUri.searchParams.append(
          "endDate",
          this.formatDate(this.range.end),
        );
        reportTableUri.searchParams.append("reportType", this.reportType);
      }
      axios
        .get(reportTableUri)
        .then((response) => {
          this.jsonresponse = response.data.reportData;

          if (this.jsonresponse != undefined && this.jsonresponse.length > 0) {
            var exportData = [];
            this.isnotActive = true;
            let reportTypeAppend = "";
            let tabName = "";
            switch (this.reportType) {
              case "Quality %":
                exportData = this.qualityReport();
                reportTypeAppend = "_Qlty%";
                tabName = "Qlty%";
                break;
              case "Timeliness %":
                exportData = this.timelinessReport();
                reportTypeAppend = "_Timeliness%";
                tabName = "Timeliness%";
                break;
              case "Quality Average Score":
                exportData = this.qualityAverageScoreReport();
                reportTypeAppend = "_Avg_Qlty_Score";
                tabName = "_Avg_Qlty_Score";
                break;
            }

            const today = new Date();
            const date =
              today.getFullYear() +
              "-" +
              (today.getMonth() + 1) +
              "-" +
              today.getDate();
            const time =
              today.getHours() +
              ":" +
              today.getMinutes() +
              ":" +
              today.getSeconds();
            const dateTime = date + "_" + time;

            const data = XLSX.utils.aoa_to_sheet(exportData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, data, tabName);
            XLSX.writeFile(
              wb,
              "TLF_Report_" + dateTime + reportTypeAppend + ".xlsx",
            );
            this.isnotActive = false;
            if (this.group.length === 1) {
              this.resetData();
            }
          } else {
            this.isnotActive = false;
            alert("No Data found !!!");
          }
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          this.isnotActive = false;
        });
    },
    downloadTabularDataForResponseRate() {
      const url = new URL(process.env.VUE_APP_BACKEND_API + this.respReportUrl);
      if (this.groups.length > 1 && !this.group) {
        url.searchParams.append("group", this.selectedGroups);
        url.searchParams.append("startDate", this.formatDate(this.range.start));
        url.searchParams.append("endDate", this.formatDate(this.range.end));
        url.searchParams.append("reportType", this.reportType);
      } else {
        url.searchParams.append("group", this.group);
        url.searchParams.append("functionsupported", this.functionSupported);
        url.searchParams.append("tasksperformed", this.task_performed);
        url.searchParams.append("startDate", this.formatDate(this.range.start));
        url.searchParams.append("endDate", this.formatDate(this.range.end));
        url.searchParams.append("reportType", this.reportType);
      }

      const request = new Request(url, {
        method: "GET",
        credentials: "include",
      });
      fetch(request)
        .then((response) => {
          if (response.headers.get("content-length") > 0) {
            return response.text();
          } else {
            throw new Error("No Data found !!!");
          }
        })
        .then((csvText) => {
          // Parse CSV text into rows
          const rows = csvText
            .trim()
            .split("\n")
            .map((row) =>
              row
                .split(",")
                .map((cell) => cell.trim().replace(/^"(.*)"$/, "$1")),
            );

          // Convert to XLSX format
          const data = XLSX.utils.aoa_to_sheet(rows);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data, "Response Rate");

          const today = new Date();
          const date =
            today.getFullYear() +
            "-" +
            (today.getMonth() + 1) +
            "-" +
            today.getDate();
          const time =
            today.getHours() +
            ":" +
            today.getMinutes() +
            ":" +
            today.getSeconds();
          const dateTime = date + "_" + time;

          XLSX.writeFile(wb, "TLF_Report_" + dateTime + "_Response_Rate%.xlsx");
          this.isnotActive = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          alert(this.errorMessage);
          this.isnotActive = false;
        });
    },
    downloadData() {
      this.usAnalystFlag = this.emails.includes(
        this.mumbaianalystid.toLowerCase(),
      );
      if (this.validateReport()) {
        if (this.group === "-Select-") {
          this.group = "";
        }
        if (this.task_performed === "-Select-") {
          this.task_performed = "";
        }

        if (this.functionSupported === "-Select-") {
          this.functionSupported = "";
        }

        this.isnotActive = true;

        if (this.selectedGroups[0] === "All") {
          this.selectedGroups.shift();
        }

        switch (this.reportType) {
          case "":
          case "Overall Report":
            //console.log('Downloading Overall Report')
            if (this.usAnalystFlag || this.mumbaianalystid == "") {
              this.stockReport();
            } else {
              alert("Enter correct Analyst email id");
              this.isnotActive = false;
              this.mumbaianalystid = "";
            }
            break;

          case "Response Rate %":
            //console.log('Downloading Response Rate %')
            this.downloadTabularDataForResponseRate();
            break;

          case "Team Lead/ Manager Comments":
            //console.log('Downloading Team Lead/ Manager Comments Report')
            this.downloadRCAReports();
            break;

          default:
            //console.log('Downloading Default Report')
            this.downloadTabularData();
        }
      }
    },
    async downloadRCAReports() {
      const params = new URLSearchParams({
        start_date: this.formatDate(this.range.start),
        end_date: this.formatDate(this.range.end),
      });
      const reportURL = "rca/report" + "?" + params;
      const request = new Request(process.env.VUE_APP_RCA_LAMBDA + reportURL, {
        method: "POST",
        body: JSON.stringify(this.selectedGroups),
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });
      const data = await fetch(request)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("Error getting response from server");
          }
        })
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.error(`${err.message}`);
          alert(err.message);
          throw new Error(err.message);
        });
      //console.log(`RES= ${JSON.stringify(data)}`)

      this.generateandDownloadReportFromJSON(data);
    },
    generateandDownloadReportFromJSON(jsonArray) {
      const reportArray = [];
      let reportRow = {};
      const headers = jsonArray.report_headers;
      console.log(jsonArray.report);
      for (let i = 0; i < jsonArray.report.length; i++) {
        // set whether manager comments applicable if yes are they provided or not
        let manager_provided_comments =
          jsonArray.report[i]["is_rca_completed"] == null
            ? "Not Applicable"
            : jsonArray.report[i]["is_rca_completed"]
            ? "Yes"
            : "No";

        reportRow = {
          "Request Id": jsonArray.report[i]["request_id"],
          "Group Name": jsonArray.report[i]["grp_name"],
          "Task Performed": jsonArray.report[i]["tasks_performed"],
          "Company Name": jsonArray.report[i]["company_name"],
          "Onshore Analyst Form Raised to":
            jsonArray.report[i]["us_analyst_id"],
          "Mumbai Analyst": jsonArray.report[i]["mumbai_analyst_id"],
          "Date of Feedback form raised": jsonArray.report[i]["feed_date"],
          "Feedback received when": jsonArray.report[i]["feed_date_us"],
          "Overall Feedback": jsonArray.report[i]["overall_feedback"],
          "Any other comments": jsonArray.report[i]["any_other_comments"],
          Timeliness: jsonArray.report[i]["timeliness"],
          "Manager Comments": jsonArray.report[i]["rca_comment"],
          "Manger Comment Date": jsonArray.report[i]["completed_on"],
          "Has Manager provided Comments": manager_provided_comments,
        };
        reportArray.push(reportRow);
      }
      //console.log(reportArray)
      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + "_" + time;

      const data = XLSX.utils.json_to_sheet(reportArray, headers);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, "TLF_Report_" + dateTime + ".xlsx");
      this.isnotActive = false;
    },
    stockReport() {
      const reportUri = new URL(process.env.VUE_APP_BACKEND_API + this.Url);

      if (this.groups.length > 1 && !this.group) {
        reportUri.searchParams.append("group", this.selectedGroups);
        reportUri.searchParams.append(
          "startDate",
          this.formatDate(this.range.start),
        );
        reportUri.searchParams.append(
          "endDate",
          this.formatDate(this.range.end),
        );
        reportUri.searchParams.append("mumbaianalystid", this.mumbaianalystid);
        reportUri.searchParams.append(
          "feedbackscore",
          this.selectedfdbscore.id,
        );
        reportUri.searchParams.append("reportType", this.reportType);
      } else {
        reportUri.searchParams.append("group", this.group);
        reportUri.searchParams.append(
          "functionsupported",
          this.functionSupported,
        );
        reportUri.searchParams.append("tasksperformed", this.task_performed);
        reportUri.searchParams.append("mumbaianalystid", this.mumbaianalystid);
        reportUri.searchParams.append(
          "startDate",
          this.formatDate(this.range.start),
        );
        reportUri.searchParams.append(
          "endDate",
          this.formatDate(this.range.end),
        );
        reportUri.searchParams.append(
          "feedbackscore",
          this.selectedfdbscore.id,
        );
        reportUri.searchParams.append("reportType", this.reportType);
      }

      axios
        .get(reportUri)
        .then((response) => {
          this.jsonresponse = response.data.reportData;

          if (this.jsonresponse != undefined && this.jsonresponse.length > 0) {
            var exportData = [];
            this.isnotActive = true;
            for (var j in this.jsonresponse) {
              var Obj = {
                "Request Id": this.jsonresponse[j]["requestId"],
                "Group Name": this.jsonresponse[j]["groupName"],
                "Task Performed": this.jsonresponse[j]["tasksPerformed"],
                "Company Name": this.jsonresponse[j]["companyName"],
                "Onshore Analyst Form Raised to":
                  this.jsonresponse[j]["usAnalystId"],
                "Date of Feedback form raised":
                  this.jsonresponse[j]["feedDate"],
                "Feedback received when":
                  this.jsonresponse[j]["feedReceivedDate"],
                "Mumbai Analyst": this.jsonresponse[j]["mumbaiAnalystId"],
                "Overall Feedback": this.jsonresponse[j]["overAllFeed"],
                "Any other comments": this.jsonresponse[j]["anyOtherComment"],
                Timeliness: this.jsonresponse[j]["timeliNess"],
              };
              exportData.push(Obj);
            }
            const today = new Date();
            const date =
              today.getFullYear() +
              "-" +
              (today.getMonth() + 1) +
              "-" +
              today.getDate();
            const time =
              today.getHours() +
              ":" +
              today.getMinutes() +
              ":" +
              today.getSeconds();
            const dateTime = date + "_" + time;

            const data = XLSX.utils.json_to_sheet(exportData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, data, "data");
            XLSX.writeFile(wb, "TLF_Report_" + dateTime + ".xlsx");
            this.isnotActive = false;
            if (this.group.length === 1) {
              this.resetData();
            }
          } else {
            this.isnotActive = false;
            alert("No Data found !!!");
          }
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          this.isnotActive = false;
        });
    },
    resetData() {
      this.reportType = "Overall Report";
      this.checkReportFlag();
      this.mumbaianalystid = "";
      this.range = {
        start: new Date(
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        ),
        end: new Date(),
      };
      this.groups = store.methods.getGroup();

      if (this.groups.length > 1) {
        this.groups = [...["All"], ...this.groups];

        this.selectedGroups.length = 0;
      }
      if (this.allSelected) {
        this.allSelected = false;
      }
      this.functionSupported = "-Select-";
      this.task_performed = "-Select-";
      this.selecteddtrange = { id: 0, text: "-Select-" };
      this.selectedfdbscore = { id: 0, text: "-Select-" };
      this.isnotActive = false;
    },
    clearfunction() {
      this.funcsuppfilteredArr = [];
      var defaultObj = { id: 0, text: "-Select-" };
      this.funcsuppfilteredArr.push(defaultObj);
      this.functionSupported = "";
    },
    cleartask() {
      this.taskperformfilteredArr = [];
      var defaultObj = { id: 0, text: "-Select-" };
      this.taskperformfilteredArr.push(defaultObj);
      this.task_performed = { id: 0, text: "-Select-" };
      this.mumbaianalystid = "";
      this.task_performed = "";
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
  },
};
</script>

<style scoped>
* {
  font-family: "Univers", HelveticaNeue, "Helvetica Neue", Helvetica, Arial,
    sans-serif;
}
.table-horizontal {
  display: table;
  width: 100%;
}

td {
  width: 20% !important;
}
.select-editable {
  position: relative !important;
  background-color: white !important;
  border: solid grey 1px !important;
  width: 273px !important;
  height: 18px !important;
}

.select-editable select {
  position: absolute !important;
  top: 0px !important;
  left: 0px !important;
  border: none !important;
  width: 273px !important;
  margin: 0 !important;
  border-bottom: solid grey 1px !important;
  border-right: solid grey 1px !important;
  border-left: solid grey 1px !important;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.select-editable input {
  position: absolute !important;
  top: 0px !important;
  left: 0px !important;
  width: 100px !important;
  padding: 1px !important;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: none !important;
  border-bottom: solid grey 1px !important;
  border-right: solid grey 1px !important;
  border-left: solid grey 1px !important;
}

.select-editable select:focus,
.select-editable input:focus {
  outline: none !important;
}

.tooltip1 {
  width: 90%;
  height: 200px;
  visibility: hidden;
  background-color: #fff;
  padding: 20px;
  -webkit-box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.5s ease;
  position: absolute;
  top: 60%;
  left: 5%;
  z-index: 1;
}

#commentdiv {
  cursor: pointer;
}

#mumbai_div {
  margin-left: 20px;
}

.mumbai {
  width: 273px;
  margin-top: 10px;
  height: 25px;
}
.reportDate {
  width: 134px;
  margin-top: 10px;
  height: 25px;
}

input[type="file"] {
  position: absolute;
  top: -500px;
}

span.remove-file {
  color: red;
  cursor: pointer;
  float: right;
}

.grayout {
  opacity: 0.6; /* Real browsers */
  filter: alpha(opacity = 60); /* MSIE */
}

.flex-container {
  display: flex;
}

.flex-child {
  flex: 1;
}
.checkBox {
  display: inline-block;
  padding-top: 0px;
  padding-bottom: 0px;
  width: 30%;
  height: 10px;
}
</style>
